import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Typography, Box, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import useLocalStorage from '../../hooks/useLocalStorage';

/**
 * @name KeepMyNumberToggle - Toggle to save user prefereance of keeping same number or get a new number
 */
const KeepMyNumberToggle = ({
  onPortingChange,
  // fadeEffect = false,
  // setFadeEffect,
  existingCustomerCheckValue,
  simOnly,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [toggleTitle, setToggleTitle] = useState();
  const [keepNumber, setKeepNumber] = useState(false);
  const [getNewNumber, setGetNewNumber] = useState(false);
  const [loadExpand, setLoadExpand] = useState(false);
  const [autoExpand, setAutoExpand] = useState(false);
  const [manualExpand, setManualExpand] = useState(false);

  const theme = useTheme();
  const { getLocalStorage, setLocalStorage, hasValue } = useLocalStorage();

  const handleChange = panel => (event, isExpanded) => {
    setLoadExpand(true);
    setExpanded(isExpanded ? panel : false);
    // if (fadeEffect) {
    //   setFadeEffect(false);
    //   setLocalStorage('portIn', 'true');
    //   // onPortingChange(true, state.simOnly);
    // }
  };
  const handleOnLoadChange = panel => (event, isExpanded) => {
    setManualExpand(isExpanded ? panel : false);
    setAutoExpand(false);
  };
  const handleKeepMyNumber = () => {
    setExpanded(false);
    // setFadeEffect(false);
    setLocalStorage('portIn', 'true');
    onPortingChange(true, simOnly);
  };
  const handleGetNewNumber = () => {
    setExpanded(false);
    // setFadeEffect(false);
    setLocalStorage('portIn', 'false');
    onPortingChange(false, simOnly);
  };

  useEffect(() => {
    if (existingCustomerCheckValue) {
      setTimeout(() => {
        setAutoExpand(true);
      }, 1000);
    }
    if (getLocalStorage('portIn') === 'false') {
      setToggleTitle('I want to get new number');
      setKeepNumber(true);
      setGetNewNumber(false);
    } else if (getLocalStorage('portIn') === 'true') {
      setToggleTitle('I want to keep my number');
      setKeepNumber(false);
      setGetNewNumber(true);
    }
  }, [getLocalStorage('portIn'), getNewNumber, keepNumber, existingCustomerCheckValue]);
  return (
    <Box sx={styles(theme).toggleAccordionMainBox}>
      {/* <Backdrop open={fadeEffect} sx={{ zIndex: 1 }} /> */}
      {hasValue('portIn') ? (
        <Accordion
          sx={
            // fadeEffect
            //   ? { ...styles(theme).toggleAccordionRoot, ...styles(theme).fadedContainer }
            //   :
            styles(theme).toggleAccordionRoot
          }
          expanded={
            expanded === 'panel1'
            // || fadeEffect === true
          }
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            sx={styles(theme).toggleAccordionSummaryRoot}
            expandIcon={<ExpandMoreIcon sx={styles(theme).expandMoreIcon} />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Typography variant='subtitle3' color={theme.palette.primary.textColor3}>
              {toggleTitle}
            </Typography>
          </AccordionSummary>
          {keepNumber && loadExpand && (
            <AccordionDetails
              tabIndex={0}
              sx={styles(theme).toggleAccordionContent}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // prevent page scroll on Space
                  handleKeepMyNumber(e); // or handleGetNewNumber
                }
              }}
              onClick={handleKeepMyNumber}
            >
              <Typography variant='subtitle3' color={theme.palette.primary.textColor5}>
                Keep my number
              </Typography>
            </AccordionDetails>
          )}
          {getNewNumber && loadExpand && (
            <AccordionDetails
              tabIndex={0}
              sx={styles(theme).toggleAccordionContent}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // prevent page scroll on Space
                  handleGetNewNumber(e); // or handleGetNewNumber
                }
              }}
              onClick={handleGetNewNumber}
            >
              <Typography variant='subtitle3' color={theme.palette.primary.textColor5}>
                Get a new number
              </Typography>
            </AccordionDetails>
          )}
        </Accordion>
      ) : (
        <Accordion
          sx={
            // fadeEffect
            //   ? { ...styles(theme).toggleAccordionRoot, ...styles(theme).fadedContainer }
            //   :
            styles(theme).toggleAccordionRoot
          }
          TransitionComponent={Collapse}
          TransitionProps={autoExpand ? { timeout: { enter: 1000 } } : {}}
          expanded={manualExpand === 'panel1' || autoExpand}
          onChange={handleOnLoadChange('panel1')}
        >
          <AccordionSummary
            sx={styles(theme).toggleAccordionSummaryRoot}
            expandIcon={<ExpandMoreIcon sx={styles(theme).expandMoreIcon} />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Typography variant='h6' color={theme.palette.primary.textColor3}>
              I want to...
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{ ...styles(theme).toggleAccordionContent, borderRadius: '0px' }}
            onClick={handleKeepMyNumber}
          >
            <Typography variant='h6' color={theme.palette.primary.textColor3}>
              Keep my number
            </Typography>
          </AccordionDetails>

          <AccordionDetails sx={styles(theme).toggleAccordionContent} onClick={handleGetNewNumber}>
            <Typography variant='h6' color={theme.palette.primary.textColor3}>
              Get a new number
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
};

export default KeepMyNumberToggle;
